/**
 * Reusable status badge for drop (Sent, Scheduled, Killed).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { cn } from '@/lib/utils';

export type DropStatusDisplay = 'Sent' | 'Scheduled' | 'Killed' | 'DRAFT';

export interface DropStatusBadgeProps {
  status: DropStatusDisplay;
  className?: string;
}

const statusStyles: Record<DropStatusDisplay, string> = {
  Sent: 'bg-success/10 text-success',
  Scheduled: 'bg-warning/10 text-warning',
  Killed: 'bg-destructive/10 text-destructive',
  DRAFT: 'bg-muted/50 text-muted-foreground',
};

export const DropStatusBadge: FC<DropStatusBadgeProps> = ({ status, className }) => (
  <span
    className={cn(
      'shrink-0 rounded-full px-2 py-0.5 text-[11px] font-medium',
      statusStyles[status],
      className,
    )}
  >
    {status}
  </span>
);
